// extracted by mini-css-extract-plugin
export default {"container":"InsightsHeader_container__I9WLm","title":"InsightsHeader_title__PTPBj"};